module.exports = __webpack_public_path__ + "static/media/omaha-skyline-at-night.0da4db4a.webp";